import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { ACCOUNTS_RECEIVABLE_SALES_JOURNAL_REPORT } from '../endpoint';
import { AccountsReceivableSalesJournalReportRequestModel } from '../models/AccountsReceivableSalesJournalReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: AccountsReceivableSalesJournalReportRequestModel): Promise<void> => {
    return await axios
      .get(`${ACCOUNTS_RECEIVABLE_SALES_JOURNAL_REPORT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'accounts-receivable-sales-journal-report',
        });
      });
  };
